import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import ParametrosRepository from './../../domains/simulador/repositories/parametros-repository';
import ConsultarRepository from './../../domains/simulador/repositories/consultar-repository';
import validarRepositoryInstance from './../../domains/simulador/repositories/validar-repository';
import CotizarInformacionRepository from './../../domains/simulador/repositories/cotizarInformacion-reposittory';
import ActualizarInformacionRepository from './../../domains/simulador/repositories/actualizarInformacion-repository';
import ConfirmarInformacionRepository from './../../domains/simulador/repositories/confirmarInformacion-repository';
import CaptchaRepository from './../../domains/simulador/repositories/captcha-repository';
import { MONEDA, STATUS, STATUS_IDLE } from '../../domains/commons/constants';
import CotizacionEnviarRepository from '../../domains/simulador/repositories/cotizacion-enviar-repository';

const initialState = {
  idSimulacion: 0,
  idCotizacion: 0,
  nombreProspecto: '',
  tipoDocumento: '1',
  nroDocumento: '',
  nombre: '',
  apePaterno: '',
  apeMaterno: '',
  fecNacimiento: '',
  genero: '',
  celular: '',
  correoEle: '',
  terminos: false,
  terminosConfir: false,

  moneda: MONEDA.PEN,
  monto: '',
  parametros: [],
  plazo: process.env.REACT_APP_PLAZO_MINIMO,

  coberturaFallecimiento: '',
  montoARecibir: '',
  porcentajeDevolucion: '',
  rentabilidadObtenida: '',
  tasaRendimiento: '',
  status: STATUS_IDLE,
  error: '',
};

export const postCaptcha = createAsyncThunk(
  'simuladorFVG/postCaptcha',
  async (token) => {
    return await new CaptchaRepository().postCaptcha(token).then((resp) => {
      return resp.data;
    });
  }
);

export const getParametrosSimulacion = createAsyncThunk(
  'simuladorFVG/getParametrosSimulacion',
  async () => {
    return await new ParametrosRepository()
      .getParametrosSimulacion()
      .then((resp) => {
        return resp.data;
      });
  }
);

export const postConsultarCreateSimulacion = createAsyncThunk(
  'simuladorFVG/postConsultarCreateSimulacion',
  async (datosConsulta) => {
    return await new ConsultarRepository()
      .postConsultarCreateSimulacion(datosConsulta)
      .then((resp) => {
        return resp.data;
      });
  }
);

export const postValidarCreatePersona = createAsyncThunk(
  'simuladorFVG/postValidarCreatePersona',
  async (datosPersona) => {
    return await validarRepositoryInstance
      .postValidarCreatePersona(datosPersona)
      .then((resp) => {
        return resp.data;
      });
  }
);

export const patchActualizarInformacion = createAsyncThunk(
  'simuladorFVG/patchActualizarInformacion',
  async (datosActualizar) => {
    return await new ActualizarInformacionRepository()
      .patchActualizarInformacion(datosActualizar)
      .then((resp) => {
        return resp.data;
      });
  }
);

export const patchConfirmarInformacion = createAsyncThunk(
  'simuladorFVG/patchConfirmarInformacion',
  async (datosActualizar) => {
    return await new ConfirmarInformacionRepository()
      .patchConfirmarInformacion(datosActualizar)
      .then((resp) => {
        return resp.data;
      });
  }
);

export const postCotizarSimulacion = createAsyncThunk(
  'simuladorFVG/postCotizarSimulacion',
  async (datosConsulta) => {
    return await new CotizarInformacionRepository()
      .postCotizarSimulacion(datosConsulta)
      .then((resp) => {
        return resp.data;
      });
  }
);

export const postCotizacionEnviar = createAsyncThunk(
  'simuladorFVG/postCotizacionEnviar',
  async (datosEnvia) => {
    return await new CotizacionEnviarRepository()
      .postCotizacionEnviar(datosEnvia)
      .then((resp) => {
        return resp.data;
      });
  }
);

export const simuladorFVGSlice = createSlice({
  name: 'simuladorFVG',
  initialState,
  reducers: {
    addDocumentoFVG: (state, action) => {
      const { tipoDocumento, nroDocumento } = action.payload;
      state.tipoDocumento = tipoDocumento;
      state.nroDocumento = nroDocumento;
    },
    addRegistroDatos: (state, action) => {
      const {
        nombre,
        apePaterno,
        apeMaterno,
        fecNacimiento,
        celular,
        correoEle,
        terminos,
        genero,
        terminosConfir,
      } = action.payload;
      state.nombre = nombre;
      state.apePaterno = apePaterno;
      state.apeMaterno = apeMaterno;
      state.fecNacimiento = fecNacimiento;
      state.genero = genero;
      state.celular = celular;
      state.correoEle = correoEle;
      state.terminos = terminos;
      state.terminosConfir = terminosConfir;
    },
    updateMoneda: (state, action) => {
      const { moneda } = action.payload;
      state.moneda = moneda;
    },
    updatePlazo: (state, action) => {
      const { plazo } = action.payload;
      state.plazo = plazo;
    },
    updateMontosResp: (state) => {
      state.coberturaFallecimiento = '0';
      state.montoARecibir = '0';
      state.porcentajeDevolucion = '0';
      state.rentabilidadObtenida = '0';
      state.tasaRendimiento = '0';
      state.idCotizacion = 0;
    },
    updateMonto: (state, action) => {
      const { monto } = action.payload;
      state.monto = monto;
    },
    updateCorreoTermino: (state, action) => {
      const { correoEle, terminos } = action.payload;
      state.correoEle = correoEle;
      state.terminos = terminos;
    },
    updateMensaje: (state, action) => {
      const { mensaje } = action.payload;
      state.mensaje = mensaje;
    },
    updateCorreoCelular: (state, action) => {
      const { celular, correoEle } = action.payload;
      state.celular = celular;
      state.correoEle = correoEle;
    },
    resetConsultarDatos: (state) => {
      if (!state.nombre) {
        state.celular = '';
        state.correoEle = '';
        state.terminos = false;
      } else {
        state.nombre = '';
        state.apePaterno = '';
        state.apeMaterno = '';
        state.fecNacimiento = '';
        state.genero = '';
        state.celular = '';
        state.correoEle = '';
        state.terminos = false;
        state.monto = '';
        state.plazo = process.env.REACT_APP_PLAZO_MINIMO;
        state.coberturaFallecimiento = '';
        state.montoARecibir = '';
        state.porcentajeDevolucion = '';
        state.rentabilidadObtenida = '';
        state.tasaRendimiento = '';
        state.idCotizacion = 0;
      }
    },
    resetState: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getParametrosSimulacion.pending, (state) => {
        state.status = STATUS.LOADED;
      })
      .addCase(getParametrosSimulacion.fulfilled, (state, action) => {
        state.status = STATUS.SUCCEEDED;
        state.parametros = action.payload.datos;
      })
      .addCase(getParametrosSimulacion.rejected, (state) => {
        state.status = STATUS.FAILED;
        state.error = 'Ocurrió un error al procesar su solicitud.';
      })

      .addCase(postConsultarCreateSimulacion.pending, (state) => {
        state.status = STATUS.LOADED;
      })
      .addCase(postConsultarCreateSimulacion.fulfilled, (state, action) => {
        if (!action.payload) {
          state.status = STATUS.SUCCEEDED;
        } else {
          state.status = STATUS.SUCCEEDED;
          state.idSimulacion = action.payload.datos.idSimulacion;
          state.nombreProspecto =
            action.payload.datos.idSimulacion === null
              ? ''
              : action.payload.datos.nombreProspecto;
          state.nombre =
            action.payload.datos.idSimulacion === null
              ? ''
              : action.payload.datos.nombreProspecto.split(' ')[0];
        }
      })
      .addCase(postConsultarCreateSimulacion.rejected, (state) => {
        state.status = STATUS.FAILED;
        state.error = 'Ocurrió un error al procesar su solicitud.';
      })

      .addCase(postValidarCreatePersona.pending, (state) => {
        state.status = STATUS.LOADED;
      })
      .addCase(postValidarCreatePersona.fulfilled, (state, action) => {
        if (!action.payload) {
          state.status = STATUS.SUCCEEDED;
        } else {
          state.status = STATUS.SUCCEEDED;
          state.idSimulacion = action.payload.datos.idSimulacion;
          state.nombreProspecto = action.payload.datos.nombreProspecto;
        }
      })
      .addCase(postValidarCreatePersona.rejected, (state) => {
        state.status = STATUS.FAILED;
        state.error = 'Ocurrió un error al procesar su solicitud.';
      })

      .addCase(patchActualizarInformacion.pending, (state) => {
        state.status = STATUS.LOADED;
      })
      .addCase(patchActualizarInformacion.fulfilled, (state, action) => {
        state.status = STATUS.SUCCEEDED;
        state.idSimulacion = action.payload.datos.idSimulacion;
      })
      .addCase(patchActualizarInformacion.rejected, (state) => {
        state.status = STATUS.FAILED;
        state.error = 'Ocurrió un error al procesar su solicitud.';
      })

      .addCase(patchConfirmarInformacion.pending, (state) => {
        state.status = STATUS.LOADED;
      })
      .addCase(patchConfirmarInformacion.fulfilled, (state, action) => {
        state.status = STATUS.SUCCEEDED;
        state.idSimulacion = action.payload.datos.idSimulacion;
      })
      .addCase(patchConfirmarInformacion.rejected, (state) => {
        state.status = STATUS.FAILED;
        state.error = 'Ocurrió un error al procesar su solicitud.';
      })

      .addCase(postCotizarSimulacion.pending, (state) => {
        state.status = STATUS.LOADED;
      })
      .addCase(postCotizarSimulacion.fulfilled, (state, action) => {
        state.status = STATUS.SUCCEEDED;
        state.coberturaFallecimiento =
          action.payload.datos.coberturaFallecimiento;
        state.montoARecibir = action.payload.datos.montoARecibir;
        state.porcentajeDevolucion = action.payload.datos.porcentajeDevolucion;
        state.rentabilidadObtenida = action.payload.datos.rentabilidadObtenida;
        state.tasaRendimiento = action.payload.datos.tasaRendimiento;
        state.idCotizacion = action.payload.datos.idCotizacion;
      })
      .addCase(postCotizarSimulacion.rejected, (state) => {
        state.status = STATUS.FAILED;
        state.error = 'Ocurrió un error al procesar su solicitud.';
      })

      .addCase(postCotizacionEnviar.pending, (state) => {
        state.status = STATUS.LOADED;
      })
      .addCase(postCotizacionEnviar.fulfilled, (state, action) => {
        state.status = STATUS.SUCCEEDED;
      })
      .addCase(postCotizacionEnviar.rejected, (state) => {
        state.status = STATUS.FAILED;
        state.error = 'Ocurrió un error al procesar envío de correo.';
      })

      .addCase(postCaptcha.pending, (state) => {
        state.status = STATUS.LOADED;
      })
      .addCase(postCaptcha.fulfilled, (state, action) => {
        state.status = STATUS.SUCCEEDED;
      })
      .addCase(postCaptcha.rejected, (state) => {
        state.status = STATUS.FAILED;
        state.error = 'Ocurrió un error al procesar su solicitud.';
      });
  },
});

export const {
  addDocumentoFVG,
  addRegistroDatos,
  updateMoneda,
  updatePlazo,
  updateMonto,
  updateCorreoTermino,
  updateMontosResp,
  updateMensaje,
  updateCorreoCelular,
  resetConsultarDatos,
  resetState,
} = simuladorFVGSlice.actions;
export default simuladorFVGSlice.reducer;
